import axios from 'axios';
import {store} from "../../../redux/store";
import {resetStore} from "../../../modules/auth/services";
import { ToastContainer, toast } from 'react-toastify';
/*global BASE_URL */
/*eslint no-undef: "error"*/

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 2000,
  headers: {

    'Accept': '*/*',
    'Content-Type': 'application/json',

  },
});

/**
 * api request interceptor
 * @param {Object} req request object
 * @returns
 */

const handleRequest = async (req) => {

  if(req.url == 'user/sign-in/google/' || req.url == 'user/sign-in/'){

    localStorage.removeItem('token')
    let action  = 'USER_LOGOUT'
    store.dispatch(resetStore(action))
  }
  let token = await store?.getState()?.auth?.user ? store?.getState()?.auth?.user?.token : null;
  if (token != null ||  token != undefined ) {
    req.headers.Authorization = `Token ${token}`;
  }

  return req;
};

/**
 * api error interceptor
 * @param {Object} error error object
 * @returns
 */
const handleError = (error) => {

  if(error?.response?.status === '401') {
    localStorage.removeItem('token')
    let action  = 'USER_LOGOUT'
    store.dispatch(resetStore(action))
    window.history.pushState({}, null, '/login');
  }else if(error?.response?.status == '403'){
    toast.warn('Access Denied')
    localStorage.removeItem('token')
    let action  = 'USER_LOGOUT'
    store.dispatch(resetStore(action))
    window.history.pushState({}, null, '/login');
  }else if(error?.response?.status == '404'){
    toast.warn('Request Failed Page Not Found')
  }
  let parsed_error = Object.assign({}, error);
  if (parsed_error.code == "ECONNABORTED" && !parsed_error.config.__isRetryRequest) {
    parsed_error.config.__isRetryRequest = true;
    return API.request(parsed_error.config);
  }
  return Promise.reject(parsed_error?.response?.data);
};

/**
 * api response interceptor
 * @param {Object} response response object
 * @returns
 */
const handleResponse = (response) => {

  return Promise.resolve(response.data);
};

  API.interceptors.request.use(handleRequest);



API.interceptors.response.use(handleResponse, handleError);

export default API;
